import { type TeamMemberRemoveInput, toResponseError, type ResponseSuccess } from '@terros/common'
import { useUserCache } from '../user'
import { useTeamCache } from '../team'
import { useTantalimMutation } from '../mutation'
import { mutationRemove, type RemoveHookResponse } from '../hooks'

export function useRemoveTeamMember(): RemoveHookResponse<TeamMemberRemoveInput> {
  const cache = useTeamCache()
  const userCache = useUserCache()
  const mutation = useTantalimMutation<TeamMemberRemoveInput, ResponseSuccess>({ url: '/team/member/remove' })

  async function remove(props: TeamMemberRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(props)
      cache.removeMembership(props)
      userCache.clearItem(props.userId)
      // A removed team role can briefly stay visible until the delayed refetch.
      userCache.syncListedRoles(props.userId, (roles) => roles)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
